export const FLW32 = {
	defaultValues: {
		height: 1000,
		width: 1000,
		windowQuantity: 1,
		ug: {
			glass3: 0.8,
			glass2: 1.1,
			panel: 1
		},
		psi: {
			glass3: 0.031,
			glass2: 0.036,
			panel: 0.03
		},
		isolation: false,
		glassThickness: 32,
		glassTypes: 2
	},
	fixedValues: {
		middleMullion: false,
		isolation: true,
		glassTypes: [
			{
				name: 'Paneele',
				value: 0
			},
			{
				name: '2-fach-Glas',
				value: 1
			},
			{
				name: '3-fach-Glas',
				value: 2
			}

		],
		ug2: [{value: 1}, {value: 1.1}, {value: 1.2}, {value: 1.3}, {value: 1.4}],
		ug3: [{value: 0.8}, {value: 0.9}],
		up: [
			{
				name: 'Vakuum-Dämmkern',
				value: 0.26
			},
			{
				name: 'PU-Dämmkern',
				value: 0.7
			},
			{
				name: 'Mineralfaser-Dämmkern',
				value: 0.85
			},
			{
				name: 'XPS-Dämmkern',
				value: 0.9
			}
		],
		psi: {
			ug3: [
				{
					name: 'Thermix TX Pro:',
					value: 0.044
				}, {
					name: 'Super Spacer TriSeal / T-Spacer Premium Plus:',
					value: 0.037
				}, {
					name: 'Ultimate SwissPacer:',
					value: 0.031
				}, {
					name: 'Advance SwissPacer:',
					value: 0.042
				}, {
					name: 'Multitech:',
					value: 0.03
				}, {
					name: 'TGI-Spacer Precision:',
					value: 0.031
				}, {
					name: 'Alu:',
					value: 0.111
				}
			],
			ug2: [
				{
					name: 'Thermix TX Pro:',
					value: 0.049
				}, {
					name: 'Super Spacer TriSeal / T-Spacer Premium Plus:',
					value: 0.042
				}, {
					name: 'Ultimate SwissPacer:',
					value: 0.036
				}, {
					name: 'Advance SwissPacer:',
					value: 0.047
				}, {
					name: 'Multitech:',
					value: 0.035
				}, {
					name: 'TGI-Spacer Precision:',
					value: 0.036
				}, {
					name: 'Alu:',
					value: 0.111
				}
			],
			up: [
				{ name: 'Vakuum-Dämmkern', value: 0.01},
				{ name: 'PU-Dämmkern', value: 0.02},
				{ name: 'Mineralfaser-Dämmkern', value: 0.03},
				{ name: 'XPS-Dämmkern', value: 0.02}
			]
		}
	},
	edgeTop: {
		W_m2K: 3.237,
		W_m2K_iso: 3.034,
		width: 65
	},
	edgeSide: {
		W_m2K: 3.313,
		W_m2K_iso: 3.112,
		width: 64
	},
	edgeBottom: {
		W_m2K: 3.21,
		W_m2K_iso: 3.016,
		width: 65
	},
	louvre: {
		W_m2K: 2.923,
		W_m2K_iso: 2.923,
		width: 46
	},
	windowWidth: {
		min: 300,
		max: 2500
	},
	windowHeight: {
		min: 340,
		max: 3000
	},
	louvreHeight: {
		min: 200,
		max: 450
	},
	edgeWidth: 40,
	gabDimensions: {
		side: 3,
		top: 4.8,
		middle: 4.8,
		bottom: 5.2
	},
	allowance: {
		width: 23,
		height: 24
	},
	area: {},

	cvReference85deg: 0.58,
	cvFactors: {cv1: 0.025, cv2: 0.025, cv3: 0.05},
	dimensionsOpenLouvre: {
		sideMullion: 42,
		profileTop: 49,
		profileBottom: 49,
		louvre: 42.8,
	},
	windLoadCalculation: {
		wl1500: [
			{
				wMax: 2414,
				hMax: 450,
				aMax: 1.09
			}
		],
		wl1750: [
			{
				wMax: 2414,
				hMax: 385,
				aMax: 0.93
			},
			{
				wMax: 2036,
				hMax: 450,
				aMax: 0.92
			}
		],
		wl2000: [
			{
				wMax: 2414,
				hMax: 385,
				aMax: 0.93
			},
			{
				wMax: 1772,
				hMax: 450,
				aMax: 0.80
			}
		],
		wl2250: [
			{
				wMax: 2414,
				hMax: 300,
				aMax: 0.72
			},
			{
				wMax: 1587,
				hMax: 450,
				aMax: 0.71
			}
		],
		wl2500: [
			{
				wMax: 2414,
				hMax: 276,
				aMax: 0.67
			},
			{
				wMax: 1428,
				hMax: 450,
				aMax: 0.64
			}
		],
		wl2750: [
			{
				wMax: 2414,
				hMax: 245,
				aMax: 0.59
			},
			{
				wMax: 1296,
				hMax: 450,
				aMax: 0.58
			}
		],
		wl3000: [
			{
				wMax: 2100,
				hMax: 225,
				aMax: 0.54
			},
			{
				wMax: 1190,
				hMax: 450,
				aMax: 0.54
			}
		]
	},

};

